import { EnvironmentProviders } from '@angular/core';
import { environment } from '@environments/environment';
import { provideMatomo, withRouter, withRouterInterceptors } from 'ngx-matomo-client';
import { MatomoInterceptor } from '../interceptors/matomo';

export function provideAnalytics(): EnvironmentProviders[] {
  return [
    provideMatomo(
      {
        trackerUrl: environment.analytics.url,
        siteId: environment.analytics.siteId,
        enableLinkTracking: true,
        disabled: !environment.analytics.enabled
      },
      withRouter(),
      withRouterInterceptors([MatomoInterceptor])
    )
  ];
}
